import React, { useState } from "react";
import BlogManager from "./BlogManager";
import { ownezzyBlog } from "../../services/blog";
import { errorMessage } from "../../services";

// Where ownezzy.com is, for the posts' "View" links: the admin panel's own domain without "admin."
const ownezzySite = () => (window.location.hostname.startsWith("admin.") ? `${window.location.protocol}//${window.location.hostname.slice(6)}` : "http://localhost:3000");

// A cover for an ownezzy.com post, uploaded with Ownezzy's platform images
function CoverUpload({ onUploaded, notify }) {
  const [busy, setBusy] = useState(false);
  const choose = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onUploaded(await ownezzyBlog.uploadCover(file));
    } catch (err) {
      notify(errorMessage(err), "error");
    } finally {
      setBusy(false);
    }
  };
  return (
    <label className="admin-field">Or upload a cover
      <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={choose} disabled={busy} />
      <small className="field-help">{busy ? "Uploading…" : "JPG, PNG, WebP or GIF · Maximum 5 MB"}</small>
    </label>
  );
}

// Super Admin: ownezzy.com's blog (ownezzy.com/blog)
export default function BlogTab({ notify }) {
  return (
    <>
      <div className="page-heading">
        <div>
          <p className="eyebrow">OWNEZZY.COM</p>
          <h1>Blog</h1>
          <p className="subheading">Posts on ownezzy.com/blog. Published posts show there straight away.</p>
        </div>
      </div>
      <section className="settings-card">
        <BlogManager api={ownezzyBlog} siteUrl={ownezzySite()} notify={notify} CoverUpload={CoverUpload} bodyHelp={'Leave an empty line between paragraphs. "## " starts a heading, lines starting with "- " make a list, **text** is bold and [label](/websites) is a link.'} />
      </section>
    </>
  );
}
